export const template = {
	type: 'doc',
	content: [
		{
			type: 'bodiedExtension',
			attrs: {
				layout: 'default',
				extensionType: 'com.atlassian.confluence.macro.core',
				extensionKey: 'details',
				parameters: {
					macroParams: {},
					macroMetadata: {
						macroId: { value: 'd858d8e03b5e1daef385609bd282d5dd' },
						schemaVersion: { value: '1' },
						title: 'Page Properties',
					},
				},
				localId: 'a750237f-a9f2-44f7-ae29-0fd5dbd51be8',
			},
			content: [
				{
					type: 'table',
					attrs: { layout: 'default' },
					content: [
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{ text: 'Target release', type: 'text', marks: [{ type: 'strong' }] },
											],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													text: 'Type // to add a target release date',
													type: 'text',
													marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }],
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [{ text: 'Epic', type: 'text', marks: [{ type: 'strong' }] }],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													text: 'Type /Jira to add Jira epics and issues',
													type: 'text',
													marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }],
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{ text: 'Document status', type: 'text', marks: [{ type: 'strong' }] },
											],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													type: 'status',
													attrs: {
														color: 'neutral',
														style: 'bold',
														text: 'DRAFT',
														localId: '185e9452-e5d1-41f2-8a2f-8575587f5a14',
													},
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{ text: 'Document owner', type: 'text', marks: [{ type: 'strong' }] },
											],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													text: '@ mention owner',
													type: 'text',
													marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }],
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [{ text: 'Designer', type: 'text', marks: [{ type: 'strong' }] }],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													text: '@ designer',
													type: 'text',
													marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }],
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [{ text: 'Tech lead', type: 'text', marks: [{ type: 'strong' }] }],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													text: '@ lead',
													type: 'text',
													marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }],
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{ text: 'Technical writers', type: 'text', marks: [{ type: 'strong' }] },
											],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [
										{
											type: 'paragraph',
											content: [
												{
													text: '@ writers',
													type: 'text',
													marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }],
												},
											],
										},
									],
								},
							],
						},
						{
							type: 'tableRow',
							content: [
								{
									type: 'tableHeader',
									attrs: { colspan: 1, rowspan: 1, colwidth: [166.0] },
									content: [
										{
											type: 'paragraph',
											content: [{ text: 'QA', type: 'text', marks: [{ type: 'strong' }] }],
										},
									],
								},
								{
									type: 'tableCell',
									attrs: { colspan: 1, rowspan: 1, colwidth: [560.0] },
									content: [{ type: 'paragraph' }],
								},
							],
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f3af', text: '🎯', shortName: ':dart:' } },
				{ text: ' Objective', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: "Provide context on this project and explain how it fits into your organization's strategic goals.",
					},
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f4ca', text: '\\uD83D\\uDCCA', shortName: ':bar_chart:' } },
				{ text: ' Success metrics', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: { text: "List project goals and the metrics you'll use to judge its success." },
				},
			],
		},
		{
			type: 'table',
			attrs: { layout: 'default' },
			content: [
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#e6fcff', rowspan: 1, colwidth: [371.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Goal', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#e6fcff', rowspan: 1, colwidth: [389.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Metric', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [371.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{ type: 'placeholder', attrs: { text: 'e.g., Simplify the user experience' } },
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [389.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'placeholder',
											attrs: { text: 'e.g., Customer satisfaction score increases' },
										},
									],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [371.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [389.0] },
							content: [{ type: 'paragraph' }],
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f914', text: '\\uD83E\\uDD14', shortName: ':thinking:' } },
				{ text: ' Assumptions', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'List any assumptions you have about your users, technical constraints, or business goals.',
					},
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f31f', text: '\\uD83C\\uDF1F', shortName: ':star2:' } },
				{ text: ' Milestones', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'Type /planner to create a visual roadmap and help your team stay on track. To edit workstreams or dates, select the placeholder and tap the pencil icon.',
					},
				},
			],
		},
		{
			type: 'extension',
			attrs: {
				layout: 'default',
				extensionType: 'com.atlassian.confluence.macro.core',
				extensionKey: 'roadmap',
				parameters: {
					macroParams: {
						maplinks: { value: '' },
						timeline: { value: 'true' },
						source: {
							value:
								'\n        %7B%22title%22%3A%22Roadmap%20Planner%22%2C%22timeline%22%3A%7B%22startDate%22%3A%222021-12-16%2000%3A00%3A00%22%2C%22endDate%22%3A%222022-07-16%2000%3A00%3A00%22%2C%22displayOption%22%3A%22MONTH%22%7D%2C%22lanes%22%3A%5B%7B%22title%22%3A%22Dashboard%22%2C%22color%22%3A%7B%22lane%22%3A%22%23f6c342%22%2C%22bar%22%3A%22%23fadb8e%22%2C%22text%22%3A%22%23594300%22%2C%22count%22%3A1%7D%2C%22bars%22%3A%5B%7B%22title%22%3A%22Feature%201%22%2C%22description%22%3A%22This%20is%20the%20first%20bar.%22%2C%22startDate%22%3A%222021-12-10%2019%3A43%3A21%22%2C%22duration%22%3A2%2C%22rowIndex%22%3A0%2C%22id%22%3A%22eeb2d902-e723-4ff0-a10d-43a5793089a4%22%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22title%22%3A%22Feature%202%22%2C%22description%22%3A%22This%20is%20the%20second%20bar.%22%2C%22startDate%22%3A%222021-12-20%2000%3A42%3A46%22%2C%22duration%22%3A2.594059405940594%2C%22rowIndex%22%3A3%2C%22id%22%3A%220e8f437c-39f1-4d70-b85b-3ca89fd57a00%22%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22rowIndex%22%3A1%2C%22startDate%22%3A%222022-03-13%2007%3A39%3A12%22%2C%22id%22%3A%2290251c8c-3b74-4d2b-b850-684ffd40514b%22%2C%22title%22%3A%22Feature%203%22%2C%22description%22%3A%22%22%2C%22duration%22%3A2.00990099009901%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22rowIndex%22%3A2%2C%22startDate%22%3A%222022-04-24%2011%3A10%3A05%22%2C%22id%22%3A%22d0529fe8-6c8c-45e8-8078-d75c2f063dd9%22%2C%22title%22%3A%22Feature%204%22%2C%22description%22%3A%22%22%2C%22duration%22%3A2.01980198019802%2C%22pageLink%22%3A%7B%7D%7D%5D%7D%2C%7B%22title%22%3A%22Notification%22%2C%22color%22%3A%7B%22lane%22%3A%22%233b7fc4%22%2C%22bar%22%3A%22%236c9fd3%22%2C%22text%22%3A%22%23ffffff%22%2C%22count%22%3A1%7D%2C%22bars%22%3A%5B%7B%22title%22%3A%22iOS%20App%22%2C%22description%22%3A%22This%20is%20the%20third%20bar.%22%2C%22startDate%22%3A%222022-01-13%2014%3A01%3A11%22%2C%22duration%22%3A2.5%2C%22rowIndex%22%3A0%2C%22id%22%3A%22dd93afcd-2704-4253-adb8-809a336cc5ba%22%2C%22pageLink%22%3A%7B%7D%7D%2C%7B%22rowIndex%22%3A0%2C%22startDate%22%3A%222022-04-23%2013%3A46%3A55%22%2C%22id%22%3A%228dc8bc2d-b7cb-44a8-b526-7d1ede51f690%22%2C%22title%22%3A%22Android%22%2C%22description%22%3A%22%22%2C%22duration%22%3A2.4752475247524752%2C%22pageLink%22%3A%7B%7D%7D%5D%7D%5D%2C%22markers%22%3A%5B%7B%22title%22%3A%22Milestone%201%22%2C%22markerDate%22%3A%222022-04-28%2007%3A50%3A29%22%7D%2C%7B%22markerDate%22%3A%222022-08-25%2020%3A40%3A23%22%2C%22title%22%3A%22Go%2FNo%20go%22%7D%2C%7B%22markerDate%22%3A%222022-06-25%2008%3A33%3A16%22%2C%22title%22%3A%22Milestone%202%22%7D%5D%7D\n    ',
						},
						pagelinks: { value: '' },
						title: { value: 'Roadmap%20Planner' },
						hash: { value: 'cfdf6478a845bded2fc6786da3b93b66' },
					},
					macroMetadata: {
						macroId: { value: 'ac0eb7fa-f06f-4569-9830-8889242be02b' },
						schemaVersion: { value: '1' },
						placeholder: [
							{
								type: 'image',
								data: {
									url: 'https://test-template.atlassian.net/wiki/plugins/servlet/roadmap/image/placeholder?hash=cfdf6478a845bded2fc6786da3b93b66&width=1000&height=300&timeline=true',
								},
							},
						],
						title: 'Roadmap Planner',
					},
				},
				localId: 'bd778e88-508d-4497-8f82-8e5c714afae8',
			},
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'Type /trello to add a card or board to this page or /jira to include a Jira issue, chart, or project.',
					},
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{
					type: 'emoji',
					attrs: { id: '1f5d2', text: '\\uD83D\\uDDD2', shortName: ':notepad_spiral:' },
				},
				{ text: ' Requirements', type: 'text' },
			],
		},
		{
			type: 'table',
			attrs: { layout: 'default' },
			content: [
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableHeader',
							attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Requirement', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, rowspan: 1, colwidth: [216.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'User Story', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, rowspan: 1, colwidth: [123.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Importance', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, rowspan: 1, colwidth: [111.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Jira Issue', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, rowspan: 1, colwidth: [106.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Notes', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{ type: 'placeholder', attrs: { text: 'e.g., Must be mobile responsive' } },
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [216.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'placeholder',
											attrs: {
												text: "e.g., John is a PM who wants to check on his team's progress from the train station",
											},
										},
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [123.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'status',
											attrs: {
												color: 'red',
												style: 'bold',
												text: 'HIGH',
												localId: '7b1e4116-8c57-4a77-9b3c-c50ea155e02d',
											},
										},
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [111.0] },
							content: [{ type: 'paragraph' }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [106.0] },
							content: [{ type: 'paragraph' }],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
							content: [{ type: 'paragraph', content: [{ text: ' ', type: 'text' }] }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [216.0] },
							content: [{ type: 'paragraph', content: [{ text: ' ', type: 'text' }] }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [123.0] },
							content: [{ type: 'paragraph', content: [{ text: ' ', type: 'text' }] }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [111.0] },
							content: [{ type: 'paragraph', content: [{ text: ' ', type: 'text' }] }],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [106.0] },
							content: [{ type: 'paragraph', content: [{ text: ' ', type: 'text' }] }],
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{ type: 'emoji', attrs: { id: '1f3a8', text: '\\uD83C\\uDFA8', shortName: ':art:' } },
				{ text: ' User interaction and design', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'Type /image to add mockups, diagrams, and screenshots related to the requirements.',
					},
				},
			],
		},
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{
					type: 'emoji',
					attrs: {
						id: 'atlassian-question_mark',
						text: ':question_mark:',
						shortName: ':question_mark:',
					},
				},
				{ text: ' Open Questions', type: 'text' },
			],
		},
		{
			type: 'table',
			attrs: { layout: 'default' },
			content: [
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#deebff', rowspan: 1, colwidth: [250.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Question', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#deebff', rowspan: 1, colwidth: [337.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Answer', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
						{
							type: 'tableHeader',
							attrs: { colspan: 1, background: '#deebff', rowspan: 1, colwidth: [173.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ text: 'Date Answered', type: 'text', marks: [{ type: 'strong' }] }],
								},
							],
						},
					],
				},
				{
					type: 'tableRow',
					content: [
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [250.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'placeholder',
											attrs: { text: 'e.g., How might we make users more aware of this feature?' },
										},
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [337.0] },
							content: [
								{
									type: 'paragraph',
									content: [
										{
											type: 'placeholder',
											attrs: {
												text: "e.g., We'll announce the feature with a blog post and a presentation",
											},
										},
									],
								},
							],
						},
						{
							type: 'tableCell',
							attrs: { colspan: 1, rowspan: 1, colwidth: [173.0] },
							content: [
								{
									type: 'paragraph',
									content: [{ type: 'placeholder', attrs: { text: 'Type // to add a date' } }],
								},
							],
						},
					],
				},
			],
		},
		{ type: 'paragraph' },
		{
			type: 'heading',
			attrs: { level: 2 },
			content: [
				{
					type: 'emoji',
					attrs: { id: 'atlassian-warning', text: ':warning:', shortName: ':warning:' },
				},
				{ text: ' Out of Scope', type: 'text' },
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'placeholder',
					attrs: {
						text: 'List the features discussed which are out of scope or might be revisited in a later release.',
					},
				},
			],
		},
		{ type: 'bulletList', content: [{ type: 'listItem', content: [{ type: 'paragraph' }] }] },
	],
	version: 1,
};
